import axios from "axios";
import { detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'

export default class PointControllerService {
    static async save(orderId,detailId, afterPointId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/points${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            },
            params: {afterPointId: afterPointId}
        });
    }

    static async delete(orderId,detailId, pointID) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patch(orderId,detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.patch(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async patchArc(orderId,detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.patch(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}/arc${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async patchRound(orderId,detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}/round${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async patchCut(orderId, detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}/cut${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async previewArc(orderId,detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}/preview-arc${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async previewRound(orderId,detailId, pointID, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/points/${pointID}/preview-round-corner${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
